/**
 * Created by augustocorvalan on 1/28/15.
 */
'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var AnchorList = module.exports = SoaModel.extend();
var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var Backbone = require('dibs-backbone');
var Anchor = require('bunsen/models/Anchor');

_.extend(AnchorList, {
    createAnchorList: function (sourceType, ids) {
        var anchors = _.map(ids, function (id) {
            if (_.isString(id)) {
                id = id.trim();
            }

            return new Anchor({
                sourceId: id,
                sourceType: sourceType
            });
        });

        return new AnchorList({ anchors: anchors });
    }
});

_.extend(AnchorList.prototype, {
    url: function () {
        return endpoints.anchorList(this.listType, this.listName);
    },
    relations: SoaModel.createRelations([
        {
            key: 'anchors',
            type: Backbone.Many,
            relatedModel: Anchor
        }
    ]),
    getIds: function () {
        var anchors = this.get('anchors');
        return anchors && anchors.pluck('sourceId');
    },

    initialize: function (attrs, options) {
        this.listType = options.listType;
        this.listName = options.listName;
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/AnchorList.js
// module id = 325
// module chunks = 62